import { useTranslation } from "react-i18next";

const CURRENCY_SYMBOLS = { MYR: "RM", SGD: "S$" };

// Box styling is inline, not a CSS class: a global ".form-group
// input[type='number']" rule elsewhere in this app's stylesheet has higher
// specificity than a plain class here and would silently re-box the input
// (border/padding/background), producing a box-inside-a-box. Inline styles
// always win over any external stylesheet rule, so the look is guaranteed
// regardless of what else is in that file.
const fieldInputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "12px 14px",
  border: "1px solid #d7dae1",
  borderRadius: 8,
  background: "#eef1f5",
  fontSize: 15,
  color: "#1f2937",
  outline: "none",
};

export default function PriceRangeInput({
  min,
  max,
  onMinChange,
  onMaxChange,
  currency = "MYR",
  disabled = false,
  minPlaceholder,
  maxPlaceholder,
}) {
  const { t } = useTranslation();
  const symbol = CURRENCY_SYMBOLS[currency] || currency;

  return (
    <div className="price-range-input">
      <div className="price-range-input-field">
        <label className="price-range-input-label">
          {t("se.displayProof.priceRangeMinLabel", {
            currency: symbol,
            defaultValue: `Min (${symbol})`,
          })}
        </label>
        <input
          type="number"
          min="0"
          step="0.01"
          inputMode="decimal"
          value={min}
          onChange={(event) => onMinChange(event.target.value)}
          placeholder={minPlaceholder}
          disabled={disabled}
          style={fieldInputStyle}
        />
      </div>
      <div className="price-range-input-field">
        <label className="price-range-input-label">
          {t("se.displayProof.priceRangeMaxLabel", {
            currency: symbol,
            defaultValue: `Max (${symbol})`,
          })}
        </label>
        <input
          type="number"
          min="0"
          step="0.01"
          inputMode="decimal"
          value={max}
          onChange={(event) => onMaxChange(event.target.value)}
          placeholder={maxPlaceholder}
          disabled={disabled}
          style={fieldInputStyle}
        />
      </div>
    </div>
  );
}
